import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { BrandColors } from '../../constants';
import { TimeLineStyle } from '../../store/interfaces';

export const verticalTimeline = makeStyles((theme: Theme) => {
  return createStyles({
    verticalgrid: (props: TimeLineStyle) => ({
      height: '100%',
      width: '1px',
      position: 'absolute',
      zIndex: 1,
      top: '0px',
      left: '50%',
      '&:before': {
        content: '""',
        position: 'absolute',
        left: '50%',
        top: '0',
        width: '1px',
        height: '100%',
        backgroundColor: `${props.lineColor}`,
      },
      '&:after': {
        content: '""',
        position: 'absolute',
        left: '50%',
        top: '70px',
        width: '12px',
        height: '12px',
        backgroundColor: props.iconContainerColor || BrandColors.white,
        border: `2px solid ${props.lineColor}`,
        borderRadius: '50%',
        transform: 'translateX(-50%)',

        [theme.breakpoints.down('sm')]: {
          top: '60px',
        },
      },
    }),

    verticalGridContentPage: (props: TimeLineStyle) => ({
      height: '100%',
      width: '1px',
      position: 'absolute',
      zIndex: 1,
      top: '0px',
      left: '50%',
      '&:before': {
        content: '""',
        position: 'absolute',
        left: '50%',
        top: '0',
        width: '1px',
        height: '100%',
        backgroundColor: props.lineColor as string,
      },
      '&:after': {
        content: '""',
        position: 'absolute',
        left: '50%',
        top: '70px',
        width: '12px',
        height: '12px',
        backgroundColor: props.iconContainerColor || BrandColors.white,
        border: `2px solid ${props.lineColor as string}`,
        borderRadius: '50%',
        transform: 'translateX(-50%)',
        [theme.breakpoints.down('sm')]: {
          top: '60px',
        },
      },
    }),

    spinner: {
      transform: 'translateX(-50%)',
      bottom: '5px',
      left: '50%',
      width: '40px',
      height: '40px',
      position: 'absolute',
      background: 'rgb(241, 242, 243)',
      borderRadius: '50%',
      [theme.breakpoints.down('md')]: {
        bottom: '5px',
      },
    },
    circle: (props: TimeLineStyle) => ({
      color: props.iconColor || BrandColors.grey100,
      width: '40px',
      height: '40px',
      paddingLeft: '0.8px',
      background: props.iconContainerColor || BrandColors.white,
      '& svg': {
        marginTop: '4px',
      },
    }),

    animated: {
      '-webkit-animation-duration': '1s',
      'animation-duration': '1s',
      '-webkit-animation-direction': 'alternate',
      'animation-direction': 'alternate',
      'animation-iteration-count': 'infinite',
    },
    bounce: {
      'animation-name': '$bounce',
      '-webkit-transform-origin': 'center bottom',
      'transform-origin': 'center bottom',
    },
    '@keyframes bounce': {
      '0%': {
        '-webkit-transition-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
        'transition-timing-function': 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
        '-webkit-transform': 'translate3d(0,0,0)',
        transform: 'translate3d(0,0,0)',
      },
      '50%': {
        '-webkit-transition-timing-function': 'cubic-bezier(.17,.67,.75,.27)',
        'transition-timing-function': 'cubic-bezier(.17,.67,.75,.27)',
        '-webkit-transform': 'translate3d(0, -2px, 0)',
        transform: 'translate3d(0, -2px, 0)',
      },
      '100%': {
        '-webkit-transition-timing-function': 'cubic-bezier(.17,.67,.75,.27)',
        'transition-timing-function': 'cubic-bezier(.17,.67,.75,.27)',
        '-webkit-transform': 'translate3d(0,-4px,0)',
        transform: 'translate3d(0,-4px,0)',
      },
    },
  });
});
